// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-layout {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: var(--background);
}

.app-layout-body {
  display: flex;
  flex: 1 1;
  align-items: flex-start;
}

.app-layout-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppLayout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".app-layout {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: var(--background);\n}\n\n.app-layout-body {\n  display: flex;\n  flex: 1;\n  align-items: flex-start;\n}\n\n.app-layout-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
